import { render, staticRenderFns } from "./GetPremiumModalAndroid.vue?vue&type=template&id=cc5a0ed2&scoped=true&"
import script from "./GetPremiumModalAndroid.vue?vue&type=script&lang=js&"
export * from "./GetPremiumModalAndroid.vue?vue&type=script&lang=js&"
import style0 from "./GetPremiumModalAndroid.vue?vue&type=style&index=0&id=cc5a0ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5a0ed2",
  null
  
)

export default component.exports